<template>
  <div>
    <v-row>
      <v-col cols="6">
        <p class="text-text-secondary mb-6">{{ $t(`project.signing-checklist.add.SigningChecklistSectionDocumentSignersCount.${sectionCaption}`) }}</p>
        <AppTextField
          v-model="signersCount"
          :disabled="isEditingLimited"
          :error-messages="signersErrorMessages"
          :placeholder="$t(`project.signing-checklist.add.SigningChecklistSectionDocumentSignersCount.${fieldPlaceholder}`)"
          required
          type="number"
          :min="0"
          @update:model-value="onSignersCountChange"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AppTextField from '@/common/AppTextField.vue'
import { formFieldErrors, VuelidateFormField } from '@/common/utils/form'
import { ENVELOPE_TYPES } from '@/project/signing-checklist/constants'

type DataType = {
  signersCountValue: number | null
}

export default defineComponent({
  name: 'SigningChecklistSectionDocumentSignersCount',
  components: {
    AppTextField,
  },
  props: {
    fileSigners: {
      type: [Array, Number],
      required: true,
    },
    fileEnvelopeType: {
      type: String,
      required: true,
    },
    isEditingLimited: {
      type: Boolean,
      required: true,
    },
    signersValidator: {
      type: Object as PropType<VuelidateFormField>,
      required: true,
    },
  },
  data (): DataType {
    return {
      signersCountValue: null,
    }
  },
  computed: {
    fieldPlaceholder (): string {
      return this.fileEnvelopeType === ENVELOPE_TYPES.SINGLE ? 'signersFieldPlaceholder' : 'signersFieldCommonPlaceholder'
    },
    sectionCaption (): string {
      return this.fileEnvelopeType === ENVELOPE_TYPES.SINGLE ? 'signersCaption' : 'signersCommonCaption'
    },
    signersCount: {
      get () : number | null {
        if (this.signersCountValue) {
          return this.signersCountValue
        } else {
          const count = Array.isArray(this.fileSigners) ? this.fileSigners.flat().length : this.fileSigners
          return count || null
        }
      },
      set (val: number | null) {
        this.signersCountValue = val
      },
    },
    signersErrorMessages () {
      return formFieldErrors(
        this.signersValidator,
        [
          ['maxValue', this.$t('project.signing-checklist.add.SigningChecklistSectionDocumentSignersCount.signersCountMaxValueError', { max: this.signersValidator['maxValue'].$params.max })],
          ['minValue', this.$t('project.signing-checklist.add.SigningChecklistSectionDocumentSignersCount.signersCountMinValueError')],
          ['required', this.$t('project.signing-checklist.add.SigningChecklistSectionDocumentSignersCount.signersCountMinValueError')],
          ['numeric', this.$t('common.validations.numeric', { fieldName: this.$t('project.signing-checklist.add.SigningChecklistSectionDocumentSignersCount.signersFieldLabel') })],
        ],
      )
    },
  },
  methods: {
    onSignersCountChange (value: number) {
      this.$emit('signers-change', value)
    },
  },
})
</script>
